import type { TimeZoneOption } from '@/types/serializers'
import { fold } from './fold.ts'
import { COLLATOR } from './locale.ts'

export interface IndexedTimeZone {
  zone: TimeZoneOption
  foldedLabel: string
  foldedTerms: string[]
}

export function indexTimeZones(zones: TimeZoneOption[]): IndexedTimeZone[] {
  return zones.map((zone) => ({
    zone,
    foldedLabel: fold(zone.label),
    foldedTerms: zone.search_terms.map(fold),
  }))
}

export function searchTimeZones(index: IndexedTimeZone[], term: string): TimeZoneOption[] {
  const folded = fold(term.trim())
  if (folded === '') return index.map((entry) => entry.zone)

  const starts: IndexedTimeZone[] = []
  const rest: IndexedTimeZone[] = []
  for (const entry of index) {
    if (!entry.foldedTerms.some((candidate) => candidate.includes(folded))) continue
    ;(entry.foldedLabel.startsWith(folded) ? starts : rest).push(entry)
  }

  starts.sort(
    (a, b) => a.zone.priority - b.zone.priority || COLLATOR.compare(a.foldedLabel, b.foldedLabel),
  )
  return [...starts, ...rest].map((entry) => entry.zone)
}
